import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import jw_decode from "jwt-decode";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Footer from "./components/Footer";
import ProjectDetail from "./pages/ProjectDetail";
import useParticles from "./utilities/particle";
import ShotDetail from "./pages/ShotDetail";
import { useEffect, useState, useContext } from "react";
import Login from "./pages/Login";
import { AuthContext } from "../src/pages/Login";
// import { signOut } from "firebase/auth";
// import { auth } from "./firebase-config";
import CreateProject from "./pages/CreateProject";
import BackToTop from "./components/BackToTop";
import BeyondWork from "./pages/BeyondWork";
import BeyondWorkDetail from "./pages/BeyondWorkDetail";

function App() {
  const { isLogin } = useContext(AuthContext);
  //const checkLogin = localStorage.getItem("isLogin");
  // const [isAuth, setIsAuth] = useState(false);
  // const signUserOut = () => {
  //   signOut(auth).then(() => {
  //     localStorage.clear();
  //     setIsAuth(false);
  //     window.location.pathname = "/";
  //   });
  // };

  // const [name, setName] = useLocal("name", "");
  // useLogger(name);
  // const mediaResult = window.matchMedia("(max-width: 375px)");
  // console.log(mediaResult.matches);

  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [scroll, setScroll] = useState(false);
  // const [user, setUser] = useState({});

  // function handleCallbackResponse(response) {
  //   console.log("Encoded JWT ID token" + response.credential);
  //   var userObject = jw_decode(response.credential);
  //   setUser(userObject);
  //   document.getElementById("signInByGoogle").hidden = true;
  // }
  // function handleSignOut(event){
  //   setUser({});
  //   document.getElementById("signInByGoogle").hidden = false;
  // }

  // function singleSignOn(){
  //   google.accounts.id.prompt();
  // }

  function SignOut(event) {
    localStorage.clear();
    document.getElementById("logout").style.display = "none";
    document.getElementById("createProject").style.display = "none";
    window.location.pathname = "/";
  }

  useEffect(() => {
    //global google
    // google.accounts.id.initialize({
    //   client_id:
    //     "574549300606-2fmp97ejmbs59kisgstknu0v85dt3vpm.apps.googleusercontent.com",
    //   callback: handleCallbackResponse,
    // });
    // google.accounts.id.renderButton(document.getElementById("signInByGoogle"), {
    //   theme: "outline",
    //   size: "large",
    // });

    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", handleWindowResize, SignOut);

    const handleScroll = () => {
      setScroll(window.scrollY > 510);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    
  }, []);

  useParticles();

  return (
    <div className="App">
      {/* <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
      /> */}
      <Router>
        <div className={`layout ${scroll ? "getNavFixed" : ""}`}>
          {isLogin ? (
            <>
              <button
                className="logout"
                id="logout"
                onClick={() => {
                  SignOut();
                }}
              >
                Logout
              </button>
              <Link to="/createProject" className="logout c" id="createProject">
                Create Project
              </Link>
            </>
          ) : (
            ""
          )}
          {/* {(typeof(localStorage.getItem("username"))=='undefined') ? 'no' : <><button className="logout" id="logout" onClick={()=>{signOut()}}>Logout</button><Link to="/createProject" className="logout c">Create Project</Link></>} */}
          {/* {!checkLogin ? <button className="logout" onClick={signOut}>Logout</button> : 'no'} */}
          {/* <div id="signInByGoogle"></div>
          {Object.keys(user).length !=0 && <button onClick={(e) => handleSignOut(e)}>Sign Out</button>} */}

          {/* <button onClick={singleSignOn}>Log-in</button> */}

          {/* { user && <div><img src={user.picture} /><h3>{user.name}</h3></div>} */}
          {/* {!isAuth ? (
            <Link to="/LetsLogin" className="logout">
              Login
            </Link>
          ) : (
            <>
              <Link to="/createProject" className="logout c">
                Create Project
              </Link>
              <button className="logout" onClick={signUserOut}>
                Logout
              </button>
            </>
          )} */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/About" element={<About />} />
            <Route path="/Projects" element={<Projects />} />
            <Route path="/BeyondWork" element={<BeyondWork />} />
            <Route path="/BeyondWork/:id" element={<BeyondWorkDetail />} />
            <Route path="/Project/:id" element={<ProjectDetail />} />
            <Route path="/Shot/:id" element={<ShotDetail />} />
            <Route
              path="/letsLogin"
              element={<Login />} //setIsAuth={setIsAuth}
            />
            <Route
              path="/createProject"
              element={<CreateProject />} //isAuth={isAuth}
            />
          </Routes>
        </div>
        <div className="srpt m0"></div>
        <BackToTop />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
